import ContactHelpers from '../helpers/ContactHelpers'
import DataHelpers from '../helpers/DataHelpers'

import Vue from 'vue'
import StringHelpers from './StringHelpers'

export default class {

    static initialiseObj(obj) {
        if(!obj.text)
            obj.text = ''
        if(!obj.html)
            obj.html = ''
        return obj
    }

    static append(obj = {}, str, attributes = {}) {
        obj = this.initialiseObj(obj)
 

        let text = str
        let html = str

        if(attributes.bold && attributes.underline) {
            text = '###### ' + text + ' ######'
            html = '<b><u>' + html + '</u></b>'
        } else {
            if(attributes.bold) {
                text = '*** ' + text + ' ***'
                html = '<b>' + html + '</b>'
            }
            if(attributes.underline) {
                text = '--- ' + text + ' ---'
                html = '<u>' + html + '</u>'
            }
        }

        if(attributes.newline) {
            text = text + '\n'
            html = html + '<br/>'
        }

        obj.text += text
        obj.html += html
        return obj
    }


    
}


// WEBPACK FOOTER //
// ./src/helpers/MultiFormat.js